import { Component } from '@angular/core';
import { HostListener } from '@angular/core';
import { normalizeCategoryTitleDivHeights,deactiveNullAnchors,setScrollCookie} from './components/globals/globals.component';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'www.CalvinParks.com';
  windowSize:Number=0;
  public normalizeCategoryTitleDivHeights = normalizeCategoryTitleDivHeights;
  public deactiveNullAnchors = normalizeCategoryTitleDivHeights;


  constructor() {


  }

  ngOnInit() {
   
  }

   public ngAfterContentInit(){  
    //alert(document.cookie);
    //alert("iside ngAfterContentInit !!! ");
    this.windowSize=window.document.body.clientWidth;
    setTimeout(normalizeCategoryTitleDivHeights,500);
    setTimeout(deactiveNullAnchors,1000);
     
  }

   public ngAfterContentChecked(){
     
    //alert("inside ngAfterContentChecked");
    if(this.windowSize!=window.document.body.clientWidth){ 
      setTimeout(normalizeCategoryTitleDivHeights,500);
    //  var scrollToY=document.cookie.split("=")[1];
    //  window.scrollTo(0,Number(scrollToY)*.68);  // adjust scrolling  by a % to position tiles correctly
   
    }
  this.windowSize=window.document.body.clientWidth;
  
  }

  @HostListener('window:beforeunload', ['$event']) 
  yourfunction($event) {
    setScrollCookie();
    /*
    var currentPageArray=document.URL.split("/");
    var currentPage=currentPageArray[currentPageArray.length-1];
    if(currentPage.length==0) currentPage="categories";
    
    //alert("test  "+"currentPage");

    var cname = currentPage;
    var cvalue = window.pageYOffset;
    var exSeconds = 60;
     
      var d = new Date();
      d.setTime(d.getTime() + (exSeconds  * 1000));
      var expires = "expires="+d.toUTCString();
      document.cookie = cname + '=; expires=Thu, 01-Jan-70 00:00:01 GMT;';
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      */
  //return $event.returnValue='Your changes will not be saved';
  }
}

interface AfterContentInit { 
  ngAfterContentInit(): void
}

interface AfterContentChecked { 
  ngAfterContentChecked(): void
}


// WEBPACK FOOTER //
// C:/Users/calvi/Documents/AngularProjects/calvinparksportfolio/src/app/app.component.ts